import CreateTemplatePage from "../components/createTemplatePage";


const CreateTemplateCreate = () => {
    return (
        <CreateTemplatePage />

    )

};

export default CreateTemplateCreate;
